module.exports = __webpack_public_path__ + "static/media/riot-logo.5371a59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/riot-logo.png
// module id = 1478
// module chunks = 39